import React from "react";
import Navigation from "./navigation/Navbar";
import {Outlet, useNavigate} from "react-router-dom";
import StatusBar from "./StatusBar";
import MainWindow from "./MainWindow";
import "./_static/Common.css";
import PdfGenerator from "./reports/PdfGenerator";
import PdfContext from "./reports/support/PdfContext";
import ProgressBar from "./dialogs/ProgressBar";
import {ModalProvider} from "./dialogs/ModalContext";
import {AppDataProvider} from "./AppDataContext";
import {getAppName} from "./Api";
import ConfigurationHandler from "./ConfigurationHandler";
import {AppStateProvider} from "./AppStateContext";

function Common(props) {

    const [pdfData, setPdfData] = React.useState({
        "generate": false,
        "reportType": null,
        "reportId": null,
        "data": null,
        "version": null,
        "preview": false
    })
    const [loggedIn, setLoggedIn] = React.useState(false)
    const navigate = useNavigate()

    function triggerPdfGeneration({reportType, reportId, data, preview, version}) {
        setPdfData({
            "generate": true,
            "reportType": reportType,
            "reportId": reportId,
            "preview": preview,
            "version": version,
            "data": data
        })
    }

    function getLogin() {
        // TO-DO: implement login properly
        const appName = getAppName()
        const logged = localStorage.getItem(`${appName}_access`)
        if (logged === "" || logged === null) {
            return false
        }
        setLoggedIn(true)
        return true
    }

    function pdfGenerationDone() {
        setPdfData({
            "generate": false,
            "reportType": null,
            "reportId": null,
            "preview": false,
            "version": null,
        })
    }

    React.useEffect(() => {
        const logged = getLogin()
        if (logged === false) {
            navigate('/login')
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        loggedIn &&
        <div className="commonWindow">
            <ModalProvider>
                <AppDataProvider>
                    <AppStateProvider>
                        <ConfigurationHandler>
                            <div className="sidebar no-print">
                                <Navigation/>
                            </div>
                            <div className="mainWrapper">
                                <StatusBar/>
                                <PdfContext.Provider value={{triggerPdfGeneration, pdfGenerationDone, setPdfData}}>
                                    <MainWindow>
                                        <Outlet/>
                                    </MainWindow>
                                    {pdfData.generate &&
                                        <>
                                            <PdfGenerator reportType={pdfData.reportType}
                                                          reportId={pdfData.reportId}
                                                          preview={pdfData.preview}
                                                          version={pdfData.version}
                                                          data={pdfData.data}
                                            />
                                            <ProgressBar/>
                                        </>
                                    }
                                </PdfContext.Provider>
                            </div>
                        </ConfigurationHandler>
                    </AppStateProvider>
                </AppDataProvider>
            </ModalProvider>
        </div>
    )
}

export default Common
